import { __assign, __rest } from "tslib";
import * as React from "react";
import clsx from "clsx";
import { Column } from "@trilogy-ds/react/lib/components/columns";
import { is } from "@trilogy-ds/react/lib/services";
import { hashClass } from "@trilogy-ds/react/lib/helpers";
import { useTrilogyContext } from "../../../context";
/**
 * Slider Item component
 * @param className {string} Additionnal css classes
 * @param children {ReactNode} Slider Item child
 * @param active {boolean} Default active item
 * @param size {number} Column Item size (1 - 12)
 */
var SliderItem = function (_a) {
    var children = _a.children, active = _a.active, className = _a.className, size = _a.size, others = __rest(_a, ["children", "active", "className", "size"]);
    var styled = useTrilogyContext().styled;
    var classes = hashClass(styled, clsx(active && is("active"), className));
    return (React.createElement(Column, __assign({ size: size || 12, className: classes }, others, { "data-slide": true }), children));
};
export default SliderItem;
//# sourceMappingURL=SliderItem.js.map